import { createContext, useContext, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./SchoolReportsUIHelpers";

const SchoolReportsUIContext = createContext();

export function useSchoolReportsUIContext() {
  return useContext(SchoolReportsUIContext);
}

export const SchoolReportsUIConsumer = SchoolReportsUIContext.Consumer;

export function SchoolReportsUIProvider({ schoolReportsUIEvents, children }) {
  const { user } = useSelector(state => state.auth);
  initialFilter.term = user.currentActiveTerm; // Mevcut Aktif Dönem Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openNewSchoolReportPage: schoolReportsUIEvents.openNewSchoolReportPage,
    openEditSchoolReportPage: schoolReportsUIEvents.openEditSchoolReportPage
  };

  return (
    <SchoolReportsUIContext.Provider value={value}>
      {children}
    </SchoolReportsUIContext.Provider>
  );
}